const coreValues = [
  { title: "Innovation", body: "We encourage creativity, critical thinking, and the exploration of new ideas in both technology and the arts." },
  { title: "Practical Learning", body: "We believe in learning by doing, ensuring that students gain hands-on experience that prepares them for real-world challenges." },
  { title: "Excellence", body: "We are committed to maintaining high standards in teaching, learning, and student achievement." },
  { title: "Integrity", body: "We promote honesty, accountability, and professionalism in all aspects of our institution." },
  { title: "Student Empowerment", body: "We support and guide students to reach their full potential and become confident, independent individuals." },
  { title: "Creativity", body: "We nurture artistic expression and innovation, especially in media, design, and digital content creation." },
  { title: "Community Development", body: "We aim to contribute positively to society by developing skills that support local industries and economic growth." },
];

const philosophy = [
  "Technical knowledge",
  "Creative thinking",
  "Problem-solving skills",
  "Entrepreneurial mindset",
];

const commitments = [
  "Providing relevant and up-to-date training.",
  "Supporting student success and career readiness.",
  "Creating a learning environment that is inclusive, supportive, and forward-thinking.",
];

export default function AboutDetails() {
  return (
    <section className="section about-details" id="about" aria-label="About Mokorotlo College">
      <div className="section__inner">
        <div className="section__header">
          <span className="section__tag">About Us</span>
          <h2 className="section__title">Background, Vision, Mission, and Values</h2>
          <p className="section__subtitle">
            A concise look at who we are, what we believe, and how we prepare students for the creative and technological world.
          </p>
        </div>

        <div className="about__background">
          <div className="about__background-text">
            <h3>Background of Mokorotlo College of Creative Technology</h3>
            <p>
              Mokorotlo College of Creative Technology is a skills-driven institution in Lesotho committed to developing talent in both creative and technological fields. The college was established to address the growing need for practical, industry-relevant education that prepares students for real-world opportunities.
            </p>
            <p>
              Over the years, the college has empowered young people with knowledge and hands-on experience in areas such as information technology, media, and digital creativity. It continues to shape individuals who can adapt to the demands of a rapidly evolving digital and creative economy.
            </p>
            <p>
              Located in Hlotse, Leribe, Mokorotlo College of Creative Technology serves students from across Lesotho, providing accessible education that focuses on both professional growth and personal development.
            </p>
          </div>
          <div className="about__image-wrap">
            <img src="/images/1.JPG" alt="Mokorotlo College campus life" loading="lazy" />
          </div>
        </div>

        <div className="about__vision-mission">
          <div className="about__card">
            <h3>Vision</h3>
            <p>
              To be a leading institution in creative and technological education in Lesotho and the region, recognized for producing innovative, skilled, and industry-ready graduates.
            </p>
          </div>
          <div className="about__card">
            <h3>Mission</h3>
            <p>
              To provide accessible, high-quality, and practical education that equips students with relevant technological and creative skills, enabling them to succeed in employment, entrepreneurship, and lifelong learning.
            </p>
          </div>
          <div className="about__image-wrap about__image-wrap--tall">
            <img src="/images/2.JPG" alt="Students collaborating at Mokorotlo College" loading="lazy" />
          </div>
        </div>

        <div className="about__values">
          <div className="about__values-header">
            <h3>Our Core Values</h3>
            <p>Principles that guide every program, project, and partnership.</p>
          </div>
          <div className="values-grid">
            {coreValues.map((item) => (
              <div key={item.title} className="values-card">
                <h4>{item.title}</h4>
                <p>{item.body}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="about__philosophy">
          <div className="about__card">
            <h3>Educational Philosophy</h3>
            <p>At Mokorotlo College of Creative Technology, education goes beyond theory. We focus on developing well-rounded individuals who are not only knowledgeable but also capable of applying their skills in real-world environments.</p>

            <p>Our approach combines technical knowledge, creative thinking, problem-solving abilities, and an entrepreneurial mindset, ensuring that graduates are prepared to adapt, innovate, and succeed in a competitive global landscape.</p>
            <ul className="about__list">
              {philosophy.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="about__card">
            <h3>Our Commitment</h3>
            <p>We are committed to:</p>
            <ul className="about__list">
              {commitments.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
